const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type ParsedCustomerIds = {
  /** Distinct well-formed ids, in first-seen order. */
  valid: string[];
  /** Tokens that are not a uuid — shown back to the operator so a bad paste is caught before submit. */
  invalid: string[];
};

// Operators paste ids straight out of Metabase, a Bull Board result or a spreadsheet column, so accept
// any mix of newlines, commas, semicolons and whitespace as separators.
export function parseCustomerIds(text: string): ParsedCustomerIds {
  const valid: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();

  for (const token of text.split(/[\s,;]+/)) {
    const value = token.trim().replace(/^["']|["']$/g, '');
    if (!value) continue;
    if (!UUID_PATTERN.test(value)) {
      invalid.push(value);
      continue;
    }
    const normalized = value.toLowerCase();
    if (seen.has(normalized)) continue;
    seen.add(normalized);
    valid.push(normalized);
  }

  return { valid, invalid };
}
